import React from "react";
import { useTranslation } from "react-i18next";
import { validatePhoneNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

function LocContactDetails({
  register,
  errors,
  firstName,
  lastName,
  email,
  number,
  labels,
}) {
  const { t, i18n } = useTranslation();

  function getNestedValue(obj, path) {
    //console.log(JSON.stringify(errors));
    console.log(path + " :::: Error");
    if (typeof path === "string" && path.includes(".")) {
      return path.split(".").reduce((acc, key) => acc?.[key], obj);
    } else {
      return obj?.[path];
    }
  }

  const firstNameError = getNestedValue(errors, firstName);
  const lastNameError = getNestedValue(errors, lastName);
  const emailError = getNestedValue(errors, email);
  const numberError = getNestedValue(errors, number);

  return (
    <>
      <div className="add-numbermain">
        <div className="tel-numbers">{t(labels?.name || "Name")}</div>
        <div className="flex-column-sm d-flex w-30">
          <div className="me-2 w-100">
            <label className="float-left">{t("firstName")}</label>
            <input maxLength={30} type="text" className="w-100" {...register(firstName, { required: "First Name is required" })} />
            {firstNameError && (
              <p className="text-danger">{firstNameError.message}</p>
            )}
          </div>
          <div className="w-100">
            <label className="float-left">{t("lastName")}</label>
            <input maxLength={20} type="text" className="w-100" {...register(lastName, { required: "Last Name is required" })} />
            {lastNameError && (
              <p className="text-danger">{lastNameError.message}</p>
            )}
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{labels?.email || "Email Address"}</div>
        <div className="w-30">
          <input
            placeholder="Email Address"
            type="text"
            // value="Jerome@panterranetworks.com"
            className="w-100"
            {...register(email, {
              setValueAs: (value) => value?.trim(),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            })}
          />
          {emailError && <p className="text-danger">{emailError.message}</p>}
          {/* <span className="seconds">{t('seconds')}</span> */}
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t(labels?.number || "Number")}</div>
        <div className="w-30">
          <input
            type="text"
            // value="97527"
            {...register(number, { validate: validatePhoneNumber })}
            className="selectname w-100"
          />
          {numberError && <p className="text-danger">{numberError.message}</p>}
        </div>
      </div>
    </>
  );
}

export default LocContactDetails;
